<template>
  <v-dialog v-model="dialogHelp" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable lazy max-width="90vw" @keydown.esc="close">
    <v-layout wrap align-start justify-start row class="layoutStyle">
      <v-flex xs12>
        <v-card color="primary" class=" pl-2 py-4">
          <span class="close-modal">
            <v-btn class="ma-0" color="error" @click.native.stop="close(true)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card>
      </v-flex>
      <v-stepper vertical>
        <v-layout color="white" wrap>
          <v-flex d-flex sm4 md3 lg2 class="tabHelp">
            <div class="helpMenu">
              <v-stepper-step editable step="1">
                Colores Incidencias
              </v-stepper-step>
            </div>
          </v-flex>
          <v-flex d-flex sm8 md9 lg10>
            <v-container fluid style="width: 80vw;">
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="white--text deep-purple darken-1" text-color="white" />
                <v-card-text class="inputStyled mt-2">
                  Incidencia finalizada
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="white--text orange darken-1" text-color="white" />
                <v-card-text class="inputStyled mt-2">
                  Incidencia anulada
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="light-green accent-3 black--text" text-color="black" />
                <v-card-text class="inputStyled mt-2">
                  Pend. de actualización
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="purple lighten-4" text-color="black" />
                <v-card-text class="inputStyled mt-2">
                  Incidencia sin asignar
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="red accent-4" text-color="white" />
                <v-card-text class="inputStyled mt-2">
                  Incidencia urgente
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="light-blue accent-2 black--text" text-color="black" />
                <v-card-text class="inputStyled mt-2">
                  Trabajo de la semana
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="green lighten-2" text-color="black" />
                <v-card-text class="inputStyled mt-2">
                  Incidencia con menos de 2 días de antigüedad
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="amber lighten-2" text-color="black" />
                <v-card-text class="inputStyled mt-2">
                  Incidencia con 3 - 4 días de antigüedad
                </v-card-text>
              </v-card>
              <v-card class="cardStyles">
                <v-chip class="chipStyled" disabled color="deep-orange lighten-2" text-color="black" />
                <v-card-text class="inputStyled mt-2">
                  Incidencia con más de 5 días de antigüedad
                </v-card-text>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-stepper>
    </v-layout>
  </v-dialog>
</template>

<script>
export default {
  name: 'Ayuda',
  data () {
    return {
      dialogHelp: false
    }
  },
  watch: {
    dialogHelp: function (value) {
      if (value) {
        document.documentElement.className += ' maximized-modal'
      } else {
        document.documentElement.className = document.documentElement.className.replace('maximized-modal', '')
        if (this.$router.history.current.query.back) {
          this.$router.go(-1)
        }
      }
    }
  },
  methods: {
    close () {
      this.dialogHelp = false
    },
    show () {
      this.dialogHelp = true
      this.$router.push({ query: { back: true } })
    }
  }
}
</script>

<style>
.chipStyled {
  width: 2vw;
}
.inputStyled {
  width: 20vw;
  padding: 3px;
  float: right;
}
.cardStyles {
  display: inline-block;
}
@media only screen and (min-width: 1904px) {
  .inputStyled {
    float: right;
    width: 68vw;
    margin-right: 2vw;
  }
  .cardStyles {
    display: inherit;
  }
}
@media only screen and (max-width: 599px) {
  .helpMenu {
    width: 40vh;
  }
  .helpMenu span {
    margin-left: 15px;
  }
  .inputStyled {
    width: 60vw;
  }
  .cardStyles {
    display: inline-block;
  }
  .layoutStyle {
    height: min-content;
  }
}
</style>
